<template>
  <lottie ref="anim" :options="defaultOptions" :height="400" :width="400" v-on:animCreated="handleAnimation"/>
</template>

<script>
  import Lottie from 'vue-lottie';
  import * as animationData from '../assets/logo_anim.json';

  export default {
    anim: null,
    components: {
      Lottie
    },
    data() {
      return {
        defaultOptions: {
          animationData: animationData.default
        },
        animationSpeed: 1
      }
    },
    methods: {
      handleAnimation: function (anim) {
        this.anim = anim;
        this.anim.setSpeed(1.35);
      },

      stop: function () {
        this.anim.stop();
      },

      play: function () {
        this.anim.play();
      },

      pause: function () {
        this.anim.pause();
      },

      mounted(){

      },

      onSpeedChange: function () {
        this.anim.setSpeed(this.animationSpeed);
      }
    }
  }
</script>